import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import LandingPage from "./camponents/LandingPage";
import Login from "./camponents/Login";
import Navbar from "./camponents/Navbar";
// import { PrivateRoute } from "./camponents/PrivateRoute";
import Profile from "./camponents/Profile";
import ProductionProductList from "./camponents/ProductionProductList";
import OrdrNav from "./camponents/OrdrNav";
import OrderList from "./camponents/OrderList";
import OrderProcess from "./camponents/OrderProcess";
import SendForProduction from "./camponents/SendForProduction";
import SendForFoodReady from "./camponents/SendForFoodReady";
import PandingPacking from "./camponents/PandingPacking";
import FoodReadyReport from "./camponents/FoodReadyReport";
import ProductionReadyReport from "./camponents/ProductionReadyReport";
import PakingReadyReport from "./camponents/PakingReadyReport";
import { useEffect, useState } from "react";
import axios from "axios";
import { AmbikaChefAPI } from "./camponents/config";
import Order from "./camponents/Order";
import SendForProductionList from "./camponents/SendForProductionList";
import { requestForToken } from "./firebase";

// import useOrderListener from "./useOrderListener";

// Improved PrivateRoute component with proper token validation
const PrivateRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation(); // Add this line to get the location

  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem("ambikaChefUserToken");
      const userId = localStorage.getItem("ambikaChefUserId");

      // Basic check - you can add API validation here if needed
      if (token && userId) {
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem("ambikaChefUserToken");
        localStorage.removeItem("ambikaChefUserId");
      }
      setIsValidating(false);
    };

    validateToken();
  }, []);

  if (isValidating) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/log-in" replace state={{ from: location }} />
  );
};

const AuthCheck = ({ children }) => {
  const token = localStorage.getItem("ambikaChefUserToken");
  const userId = localStorage.getItem("ambikaChefUserId");
  const navigate = useNavigate();

  if (token && userId) {
    navigate("/orders", { replace: true });
    return null;
  }
  return children;
};

function App() {
  const [orderList, setOrderList] = useState(null);
  const location = useLocation();

  const isActiveLink = (link) => {
    return link === location.pathname;
  };

  const ambikaChefUserToken = localStorage.getItem("ambikaChefUserToken");
  const ambikaChefUserId = localStorage.getItem("ambikaChefUserId");

  useEffect(() => {
    if (!ambikaChefUserId || !ambikaChefUserToken) return;

    if (!("Notification" in window)) {
      console.warn("🚫 Notifications are not supported in this browser.");
      return;
    }

    if ("Notification" in window) {
      if (Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            requestForToken(ambikaChefUserId, ambikaChefUserToken);
          } else {
            console.warn("🚫 Notification denied by user");
          }
        });
      }
    }
  }, [ambikaChefUserId, ambikaChefUserToken]);

  const itemStatu = () => {
    axios
      .post(
        `${AmbikaChefAPI}/chef/chefDashboard`,
        { UserId: ambikaChefUserId },
        { headers: { Authorization: `Bearer ${ambikaChefUserToken}` } }
      )
      .then((res) => {
        setOrderList(res?.data?.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    itemStatu();
  }, []);
  return (
    <div className="App">
      {isActiveLink("/") || isActiveLink("/log-in") ? (
        ""
      ) : (
        <>
          <Navbar />
          <div style={{ height: "70px" }}></div>
          {isActiveLink("/profile") ? (
            ""
          ) : (
            <OrdrNav orderList={orderList} refreshOrders={itemStatu} />
          )}
        </>
      )}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/log-in"
          element={
            <AuthCheck>
              <Login />
            </AuthCheck>
          }
        />
        <Route
          path="/orders"
          element={
            <PrivateRoute>
              <Order orderList={orderList} refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />

        {/* <Route path='/orders' element={<PrivateRoute><ShowOrder /></PrivateRoute>} /> */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/production-product"
          element={
            <PrivateRoute>
              <ProductionProductList refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/order-place"
          element={
            <PrivateRoute>
              <OrderList refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/accepted-order"
          element={
            <PrivateRoute>
              <OrderProcess refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-for-production"
          element={
            <PrivateRoute>
              <SendForProduction refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-for-production-list"
          element={
            <PrivateRoute>
              <SendForProductionList refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/production-ready"
          element={
            <PrivateRoute>
              <SendForFoodReady refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/pending-packing"
          element={
            <PrivateRoute>
              <PandingPacking refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/food-ready-report"
          element={
            <PrivateRoute>
              <FoodReadyReport refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/production-ready-report"
          element={
            <PrivateRoute>
              <ProductionReadyReport refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route
          path="/packing-ready-report"
          element={
            <PrivateRoute>
              <PakingReadyReport refreshOrders={itemStatu} />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
